import React, { useState } from 'react';
import { Alert, Box, Button, Container, Paper, Stack, TextField, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import api from '../api/axios';

const AdminSalesLoginPage: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (event: React.FormEvent) => {
    event.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const response = await api.post('/sales-admin/auth/login', { email, password });
      localStorage.setItem('sales_admin_auth', JSON.stringify(response.data));
      navigate('/sales-admin', { replace: true });
    } catch (err: any) {
      setError(err?.response?.data?.message || 'Giriş yapılamadı. Bilgilerinizi kontrol edin.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', bgcolor: '#f5f7fb', px: 2 }}>
      <Container maxWidth="xs">
        <Paper component="form" onSubmit={submit} elevation={0} sx={{ p: 4, borderRadius: 3, border: '1px solid', borderColor: 'divider' }}>
          <Typography variant="h4" fontWeight={700}>Admin-Sales Login</Typography>
          <Typography color="text.secondary" sx={{ mt: 1, mb: 3 }}>Livaxu satış yönetim paneline giriş yapın.</Typography>
          <Stack spacing={2}>
            <TextField label="E-posta" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus />
            <TextField label="Şifre" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
            {error && <Alert severity="error">{error}</Alert>}
            <Button type="submit" variant="contained" size="large" disabled={loading}>{loading ? 'Giriş yapılıyor...' : 'Giriş Yap'}</Button>
            <Button type="button" color="inherit" onClick={() => navigate('/')}>Geri dön</Button>
          </Stack>
        </Paper>
      </Container>
    </Box>
  );
};

export default AdminSalesLoginPage;
